import { jsx as _jsx } from "react/jsx-runtime";
import { Popper } from '@mui/material';
// https://github.com/mui/material-ui/issues/19376#issuecomment-1518491451
export const AutosizedPopper = (props) => {
    return _jsx(Popper, { ...props, style: { width: 'auto' } });
};
